import React from 'react';
export function InsidePreviewSection() {
  const videos = [{
    title: 'Teoría y Fundamentos',
    description: 'Todo lo que necesitás saber antes de empezar.',
    url: 'https://cdn.magicpatterns.com/uploads/nzeUwPzGF7wsUm8EGcSXhZ/WhatsApp Video 2026-05-19 at 7.03.35 PM.mp4'
  }, {
    title: 'Rutinas Paso a Paso',
    description: 'Ejercicios explicados al detalle para que no te pierdas.',
    url: 'https://cdn.magicpatterns.com/uploads/rKtmBmLW4Kb6o1Uemnk9Qp/WhatsApp Video 2026-05-19 at 7.03.44 PM.mp4'
  }, {
    title: 'Tus 10 Bonos',
    description: 'Recetas, meal prep, licuados y mucho más.',
    url: 'https://cdn.magicpatterns.com/uploads/dMEbkiumtkq6nZaF1G2CAw/WhatsApp Video 2026-05-19 at 7.15.17 PM.mp4'
  }];
  return <section className="py-12 md:py-16 bg-gray-900 text-white overflow-hidden" data-id="element-179">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-180">
        <div className="text-center mb-12" data-id="element-181">
          <div className="inline-block bg-brand-pink-600 text-white px-4 py-1.5 rounded-full text-xs font-bold uppercase tracking-wider mb-3" data-id="element-182">
            Sin secretos
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl mb-4" data-id="element-183">
            MIRÁ EL PROGRAMA POR DENTRO
          </h2>
          <p className="text-base md:text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-184">
            Un vistazo rápido a la calidad del material que te llevás hoy. Todo
            diseñado para que sea fácil de leer y aplicar desde tu celular.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-185">
          {videos.map((video, i) => <div key={i} className="flex flex-col items-center" data-id="element-186">
              {/* Phone Mockup */}
              <div className="relative w-[240px] h-[480px] bg-black rounded-[3rem] border-[8px] border-gray-800 shadow-2xl overflow-hidden mb-6 transform transition-transform hover:-translate-y-2" data-id="element-187">
                {/* iPhone Notch */}
                <div className="absolute top-0 inset-x-0 h-6 bg-gray-800 rounded-b-3xl w-32 mx-auto z-20" data-id="element-188" />

                <video src={video.url} autoPlay muted loop playsInline className="w-full h-full object-cover z-10 relative" data-id="element-189" />
              </div>

              <div className="text-center px-4" data-id="element-190">
                <h3 className="text-xl font-bold text-white mb-2" data-id="element-191">
                  {video.title}
                </h3>
                <p className="text-sm text-gray-400" data-id="element-192">{video.description}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}